import { HttpResponse } from '@angular/common/http';
import { AppConfig } from '@app/app.config';
import {
	getDeepFromObject,
	NbAuthOAuth2Token,
	NbAuthOptions
} from '@nebular/auth';
import { PasswordAuthStrategy, PasswordAuthStrategyOptions } from './strategy';

export const authenticationOptions: (
	appConfig: typeof AppConfig
) => NbAuthOptions = (appConfig: typeof AppConfig) => ({
	strategies: [
		PasswordAuthStrategy.setup({
			name: 'auth-username-password',
			clientId: AppConfig.authentication.clientId,
			clientSecret: AppConfig.authentication.clientSecret,
			grantType: 'password',
			baseEndpoint: '',
			login: {
				endpoint: `${AppConfig.authentication.baseUrl}/oauth/token`,
				method: 'POST',
				defaultErrors: ['LOGIN.ERRORS.GENERIC']
			},
			refreshToken: {
				method: 'POST',
				endpoint: `${AppConfig.authentication.baseUrl}/oauth/token`
			},
			resetPass: {
				method: 'POST',
				defaultErrors: ['RESET_PASSWORD.ERROR_MESSAGE'],
				emailLinkReset: 'auth/cambio-password',
				endpoint: `${appConfig.backend.baseUrl}/apiNeta2DPortal/v1.0/ResetPassword`
			},
			token: {
				class: NbAuthOAuth2Token,
				getter: (
					module: string,
					res: HttpResponse<object>,
					// eslint-disable-next-line @typescript-eslint/no-unused-vars
					options: PasswordAuthStrategyOptions
				) => {
					return getDeepFromObject(res.body, '', res.body);
				}
			}
		})
	],
	forms: {
		login: {
			redirectDelay: 0, // delay before redirect after a successful login, while success message is shown to the user
			strategy: 'auth-username-password', // strategy id key.
			showMessages: {
				success: false,
				error: true
			}
		},
		logout: {
			redirectDelay: 0,
			strategy: 'auth-username-password'
		},
		resetPassword: {
			redirectDelay: 500,
			strategy: 'auth-username-password',
			showMessages: {
				success: true,
				error: true
			}
		},
		refreshToken: {
			redirectDelay: 0, // delay before redirect after a successful login, while success message is shown to the user
			strategy: 'oath2', // strategy id key.
			rememberMe: true, // whether to show or not the `rememberMe` checkbox
			showMessages: {
				// show/not show success/error messages
				success: true,
				error: true
			}
		},
		validation: {
			username: {
				required: true
			},
			password: {
				required: true
			}
		}
	}

	//   NbOAuth2AuthStrategy.setup({
	//     name: 'oath2',
	//     clientId: environment.authentication.clientId,
	//     clientSecret: environment.authentication.clientSecret,
	//     clientAuthMethod: NbOAuth2ClientAuthMethod.REQUEST_BODY,
	//     token: {
	//       endpoint: appConfig.authentication.loginUrl,
	//       grantType: NbOAuth2GrantType.PASSWORD,
	//       class: NbAuthOAuth2Token
	//     },
	//     refresh: {
	//       endpoint: appConfig.authentication.loginUrl,
	//       grantType: NbOAuth2GrantType.REFRESH_TOKEN
	//     }
	//   })
	// ],

	// PasswordAuthStrategy.setup({
	//   name: 'username',
	//   // baseEndpoint: environment.backend.loginBaseUrl,
	//   login: {
	//     alwaysFail: false,
	//     endpoint: 'login',
	//     method: 'POST',
	//     requireValidToken: false,
	//     redirect: {
	//       success: '/',
	//       failure: null
	//     },
	//     defaultErrors: ['LOGIN.ERROR_MESSAGE'],
	//     defaultMessages: ['LOGIN.SUCCESS_MESSAGE']
	//   },
	//   resetPass: {
	//     alwaysFail: false,
	//     endpoint: 'resetPass',
	//     method: 'POST',
	//     requireValidToken: false,
	//     redirect: {
	//       success: '/',
	//       failure: null
	//     },
	//     defaultErrors: ['RESET_PASSWORD.ERROR_MESSAGE'],
	//     defaultMessages: ['RESET_PASSWORD.SUCCESS_MESSAGE']
	//   },
	//   refreshToken: {
	//     alwaysFail: false,
	//     endpoint: 'refreshToken',
	//     method: 'POST',
	//     requireValidToken: true,
	//     redirect: {
	//       success: '/',
	//       failure: null
	//     },
	//     defaultErrors: ['RESET_PASSWORD.ERROR_MESSAGE'],
	//     defaultMessages: ['RESET_PASSWORD.SUCCESS_MESSAGE']
	//   },
	//   // logout: {
	//   //   alwaysFail: false,
	//   //   endpoint: '/logout',
	//   //   method: 'DELETE',
	//   //   redirect: {
	//   //     success: '/',
	//   //     failure: null
	//   //   },
	//   //   defaultErrors: ['Something went wrong, please try again.'],
	//   //   defaultMessages: ['You have been successfully logged out.']
	//   // }

	//   token: {
	//     class: NbAuthSimpleToken,
	//     key: 'access_token'
	//     // getter
	//   }
	// })
});
